<template>
  <button class="back-button" @click="handleClick">
    <icon name="ArrowLeftFilled" />
    zurück
  </button>
</template>

<script setup lang="ts">
const router = useRouter()

const props = defineProps<{
  to: string
}>()

function handleClick (): void {
  // We don't have an internal route. We simply fall back to the default route provided.
  if (router.options.history.state.back === null) {
    navigateTo(props.to)
    return
  }

  // If the user navigated from an internal url and if so just go back in history.
  router.back()
}
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.back-button {
  @include tools.button-borderless;
  @include tools.typo-button-small;
  display: flex;
  align-items: center;
  gap: 15px;
  grid-column: 1 / span 6;
  padding-left: 0;
  padding-right: 0;

  &:hover {
    color: var(--color-text);
    background-color: var(--color-background);
  }
}
</style>
